// @ts-nocheck: converted from JS

import PasswordForget from './PasswordForget';

export default PasswordForget;
